import { postFetch } from '../utils/fetch';
import { AUTH_LOGIN_API } from './config';

export function login(data) {
  console.log(AUTH_LOGIN_API())
  return postFetch(AUTH_LOGIN_API(), data);
}



// WEBPACK FOOTER //
// ./src/api/auth.js